import { render, staticRenderFns } from "./SubServiceColumn.vue?vue&type=template&id=09895d43&scoped=true&"
import script from "./SubServiceColumn.vue?vue&type=script&lang=js&"
export * from "./SubServiceColumn.vue?vue&type=script&lang=js&"
import style0 from "./SubServiceColumn.vue?vue&type=style&index=0&id=09895d43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09895d43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemContent})
